<template>
  <gh-table-page ref="table" sort-by="Seq" :tabs="tabs" :args-query="args" module="plat.menu" cls="MenuService"
    :template-model="modelTemplate" @pageConfig="configPage" :beforeRowIntial="beforeIntial">
    <template #area_left>
      <v-layout column wrap>
        <gh-business-tree ref="tree" :attached-all="true" v-model="parent" module="plat.menu" cls="MenuService">
          <template v-slot="{node,data}">
            <v-icon small color="primary">{{data.icon}}</v-icon>{{data.Name}}
          </template>
        </gh-business-tree>
      </v-layout>
    </template>
    <!-- <template #area_operation_new="{addItem}">
      <v-btn v-show="AllowAdd" color="success" @click="addItem">新增</v-btn>
    </template> -->
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Menu from "./menu.ts";
  export default Menu;
</script>